module.exports = "<p>\n  faq works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/faq/faq.component.html
// module id = ./src/app/components/faq/faq.component.html
// module chunks = main